import { CSSProperties } from 'react';
import { SvgProps } from '@/components/icons/svg';

export interface PrinterlessProps extends SvgProps {
  ariaTitle?: string;
}

export default function Printerless({ s }: { s?: CSSProperties }) {
  return (
    <svg
      width="31"
      height="30"
      viewBox="0 0 31 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ ...s, verticalAlign: 'middle' }}
    >
      <path
        fillRule="evenodd"
        d="M25.0123 25.7791C25.0123 26.0594 24.7774 26.2871 24.4876 26.2871H17.2564L17.257 23.477C17.257 23.4758 17.2564 23.4747 17.2564 23.4735V23.4461C17.2564 22.9569 16.8515 22.5599 16.3528 22.5599H11.5768C11.0787 22.5599 10.6732 22.9569 10.6732 23.4461V26.2871H3.25958C2.96979 26.2871 2.73489 26.0594 2.73489 25.7791V10.1374H10.6283H10.6732V12.7805C10.6732 13.2496 11.0787 13.6318 11.5768 13.6318H16.3528C16.8515 13.6318 17.2564 13.2496 17.2564 12.7805L17.2546 10.1374H17.3024H25.0123V25.7791ZM16.521 26.2872H11.4086L11.4092 23.477C11.4092 23.3815 11.4847 23.3037 11.5774 23.3037H16.354C16.4454 23.3037 16.5198 23.3809 16.521 23.4753V26.2872ZM6.34519 2.89196C6.40362 2.7844 6.51694 2.71632 6.6403 2.71575L11.5178 2.71289L10.7133 9.42471H2.96389L6.34519 2.89196ZM16.521 10.1374V12.7805C16.521 12.8566 16.4455 12.919 16.3528 12.919H11.5769C11.4842 12.919 11.4086 12.8566 11.4086 12.7805L11.4069 10.1374H16.521ZM15.75 3.39708L16.4766 9.42468H11.4539L12.2589 2.71343L15.668 2.71686L15.75 3.39708ZM21.0773 2.72315C21.206 2.72315 21.3216 2.79237 21.3801 2.90565L24.782 9.42467H17.2167L16.4088 2.71914L21.0773 2.72315ZM25.7081 9.62031L22.037 2.58525C21.854 2.23113 21.4875 2.01087 21.0785 2.0103L16.3226 2.00629V2.00515L11.9308 2H11.922H11.6033V2.00057L6.63786 2.00286C6.23947 2.00515 5.87649 2.21968 5.69057 2.56752L2.03836 9.62146C2.01298 9.67123 2 9.72558 2 9.78107V25.7791C2 26.4525 2.56483 27 3.2595 27H10.6731H11.0408H16.8886H17.2563H24.4875C25.1822 27 25.7476 26.4525 25.7476 25.7791V9.78107C25.7476 9.72558 25.734 9.67008 25.7081 9.62031Z"
        fill="black"
      />
      <path
        d="M30.8663 18.0823C30.8663 21.1744 28.3596 23.6811 25.2674 23.6811C22.1753 23.6811 19.6686 21.1744 19.6686 18.0823C19.6686 14.9901 22.1753 12.4834 25.2674 12.4834C28.3596 12.4834 30.8663 14.9901 30.8663 18.0823Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        d="M25.2674 23.0413C28.0062 23.0413 30.2264 20.821 30.2264 18.0823C30.2264 15.3435 28.0062 13.1233 25.2674 13.1233C22.5287 13.1233 20.3084 15.3435 20.3084 18.0823C20.3084 20.821 22.5287 23.0413 25.2674 23.0413ZM25.2674 23.6811C28.3596 23.6811 30.8663 21.1744 30.8663 18.0823C30.8663 14.9901 28.3596 12.4834 25.2674 12.4834C22.1753 12.4834 19.6686 14.9901 19.6686 18.0823C19.6686 21.1744 22.1753 23.6811 25.2674 23.6811Z"
        fill="black"
      />
      <path d="M23.2679 16.0841H23.9877V16.804H23.2679V16.0841Z" fill="black" />
      <path
        d="M24.7076 15.3643V17.5238H22.548V15.3643H24.7076ZM24.3476 15.7242H22.9079V17.1639H24.3476V15.7242Z"
        fill="black"
      />
      <path
        d="M23.9877 19.6834H23.2679V20.4032H23.9877V19.6834Z"
        fill="black"
      />
      <path
        d="M24.7076 18.9635V21.1231H22.548V18.9635H24.7076ZM22.9079 19.3235V20.7632H24.3476V19.3235H22.9079Z"
        fill="black"
      />
      <path d="M26.8671 16.0841H27.587V16.804H26.8671V16.0841Z" fill="black" />
      <path
        d="M26.1473 15.3643V17.5238H28.3068V15.3643H26.1473ZM27.9469 15.7242V17.1639H26.5072V15.7242H27.9469Z"
        fill="black"
      />
      <path
        d="M25.4274 15.7242V15.3643H25.7874V16.0841H25.4274V16.804H25.0675V15.7242H25.4274Z"
        fill="black"
      />
      <path d="M25.4274 17.5238V16.804H25.7874V17.5238H25.4274Z" fill="black" />
      <path
        d="M24.7076 18.2437V17.8837H25.0675V17.5238H25.4274V18.2437H25.7874V17.8837H27.587V18.2437H26.1473V18.6036H25.0675V18.2437H24.7076Z"
        fill="black"
      />
      <path
        d="M24.7076 18.2437V18.6036H23.2679V18.2437H22.9079V18.6036H22.548V17.8837H23.6278V18.2437H24.7076Z"
        fill="black"
      />
      <path
        d="M28.3068 18.6036H27.9469V17.8837H28.3068V18.6036Z"
        fill="black"
      />
      <path
        d="M27.9469 18.6036H27.587V19.3235H28.3068V18.9635H27.9469V18.6036Z"
        fill="black"
      />
      <path
        d="M26.5072 18.6036H27.2271V18.9635H26.8671V19.3235H26.5072V18.6036Z"
        fill="black"
      />
      <path
        d="M27.2271 19.6834V19.3235H26.8671V19.6834H26.5072V20.0433H25.7874V20.4032H26.8671V19.6834H27.2271Z"
        fill="black"
      />
      <path
        d="M27.2271 19.6834H28.3068V20.0433H27.587V20.4032H27.2271V19.6834Z"
        fill="black"
      />
      <path
        d="M25.7874 19.3235V19.6834H26.1473V18.9635H25.0675V19.3235H25.7874Z"
        fill="black"
      />
      <path
        d="M25.0675 19.6834H25.4274V20.7632H26.8671V21.1231H25.0675V19.6834Z"
        fill="black"
      />
      <path
        d="M28.3068 20.4032V21.1231H27.2271V20.7632H27.9469V20.4032H28.3068Z"
        fill="black"
      />
    </svg>
  );
}
